import { render } from "./PhotographStory.vue?vue&type=template&id=554ab38a&scoped=true"
import script from "./PhotographStory.vue?vue&type=script&lang=js"
export * from "./PhotographStory.vue?vue&type=script&lang=js"

import "./PhotographStory.vue?vue&type=style&index=0&id=554ab38a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-554ab38a"]])

export default __exports__